import { withTZ } from '../../../../../../helpers/dateTime';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';

const initState = {
  sessions: [],
  isLoading: false,
};

function onLoad(state) {
  return {
    ...state,
    isLoading: true,
  };
}

const getFormattedRecords = data => {
  const { records } = data;

  return records.map(item => {
    return {
      id: item.id,
      date: item.starts_at,
      start: withTZ(item.starts_at),
      end: withTZ(item.finishes_at),
      workers_assigned: item.workers_assigned,
      workers_required: item.workers_required,
    };
  });
};
function onLoadSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    sessions: getFormattedRecords(payload, state),
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
